import styled, { keyframes } from "styled-components";

import {
  DATA_E2E_KEY,
  DRAWER_CONTENT_FADE_IN_DURATION_S,
  DRAWER_MOTION_ENTER_OPACITY,
  IStyledAttributes,
} from "@ryde/shared";

const fadeIn = keyframes`
  from {
    opacity: ${DRAWER_MOTION_ENTER_OPACITY};
  }
  to {
    opacity: 1;
  }
`;

export const DrawerContentFadeInStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "drawer-content-fade-in-styled",
})`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;

  @media (prefers-reduced-motion: no-preference) {
    animation: ${fadeIn} ${DRAWER_CONTENT_FADE_IN_DURATION_S}s ease-out both;
  }
`;
